// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2r3xg","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__ukpAt"};